import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<p>The formula has been prior authorized and may be provided. This authorization has been selected for medical review. The medical record supporting this request must be sent to the medical prior approval bureau within 30 days. Mail records to: Office of Health Insurance Programs, 150 Broadway, Albany, New York 12204. Failure to submit the requested documentation may lead to the rejection of future authorization requests.</p>
				
				<div className="button" onClick={()=>this.props.navigate('R28')}>Okay</div>
			</div>
		);
	}
}